import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TableSearchService {
   private searchUpdatedSubject$ = new Subject<string>();

   get searchUpdated$() {
       return this.searchUpdatedSubject$.asObservable();
   }

    searchUpdated(value: any) {
        this.searchUpdatedSubject$.next(value);
    }
}
